import { Pipe, PipeTransform } from '@angular/core';
import { findCurrency } from 'currency-formatter';
import findLast from 'lodash-es/findLast';

import { environment } from '@environment';
import { isEmpty } from '@app/util/util';

export const MILLION = 1000000;
export const THOUSAND = 1000;

const LOOKUP = [
  { value: 1, symbol: '' },
  { value: THOUSAND, symbol: 'K' },
  { value: MILLION, symbol: 'M' },
];

@Pipe({
  name: 'priceAbbreviation',
  standalone: false
})
export class PriceAbbreviationPipe implements PipeTransform {

  transform(price: number, showCurrency: boolean | undefined = false): string {
    const response = findLast(LOOKUP, ({ value }) => price >= value);
    const currencyData = findCurrency(environment.countryInfo.currency_code);
    const priceValue = response ? `${(price / response.value)}` : `${price}`;
    const priceParts = getPriceParts(priceValue);
    const formatted = getPriceFormatted(priceParts);
    const printed = printPrice(formatted, showCurrency, currencyData.symbol, currencyData.symbolOnLeft);
    return response ? printed.concat(response.symbol) : printed;
  }
}

function getPriceParts(price: string): string[] {
  const _priceParts = price.split('.');
  if (_priceParts?.[1]) {
    _priceParts[1] = _priceParts[1].substring(0, 1).replace('0', '');
  }
  return _priceParts;
}

function getPriceFormatted(_priceParts: string[]): string {
  return !isEmpty(_priceParts?.[1]) ? `${_priceParts[0]}.${_priceParts[1]}` : _priceParts[0];
}

function printPrice(formatted: string, showCurrency: boolean, symbol: string, symbolOnLeft: boolean): string {
  if (showCurrency) {
    return (symbolOnLeft ? `${symbol}${formatted}` : `${formatted}${symbol}`);
  } else {
    return formatted;
  }
}
